import {
  FindListingsResponse,
  FindMapListingResponse,
  Listing,
} from '@kamernet/core/ApiClient/Kamernet';
import {
  MAP_INITIAL_ZOOM_SIZE,
  MAP_INITIAL_LATITUDE,
  MAP_INITIAL_LONGITUDE,
} from '@kamernet/constants/Listings';

import { areCoordsEqual } from './areCoordsEqual';

export const tranformMapListingToRegularListing = (
  mapListing: FindMapListingResponse,
) => {
  const listingArray: Array<Listing> = [];
  // eslint-disable-next-line array-callback-return
  mapListing.listings.map(listing => {
    const lisitingItem: Listing = {
      listingId: listing.listingId,
      thumbnailUrl: listing.thumbnailUrl || '',
      fullPreviewImageUrl: listing.thumbnailUrl || '',
      isTopAdvert: listing.hasMoveUp,
      isReactForFree: listing.reactForFree,
      furnishingId: listing.furnishingId,
      availabilityEndDate: listing.availabilityEndDate,
      availabilityStartDate: listing.availabilityStartDate,
      street: listing.streetName,
      streetSlug: listing.streetSlug,
      city: listing.cityName,
      citySlug: listing.citySlug,
      isFavorite: listing.isFavorite,
      surfaceArea: listing.surface,
      listingType: listing.listingType,
      totalRentalPrice: listing.price,
      utilitiesIncluded: false,
      isNewAdvert: false,
      isStudentHouseAdvert: listing.isStudentHouseAdvert,
      studentHouseId: listing.studentHouseId,
    };
    listingArray.push(lisitingItem);
  });
  const listingResponse: FindListingsResponse = {
    listings: listingArray,
    OpResponse: mapListing.OpResponse,
    LogEntryId: mapListing.LogEntryId,
    nearbyListings: [],
    topAdListings: [],
    total: listingArray.length,
  };
  return listingResponse;
};

export const isMapInInitialState = (lat: number, lng: number, zoom: number) => {
  return (
    !!MAP_INITIAL_LATITUDE &&
    areCoordsEqual(lat, MAP_INITIAL_LATITUDE) &&
    !!MAP_INITIAL_LONGITUDE &&
    areCoordsEqual(lng, MAP_INITIAL_LONGITUDE) &&
    zoom === MAP_INITIAL_ZOOM_SIZE
  );
};
